import { Component } from "react";
import { FixedSizeList as List } from "react-window";

// The name of this component has to be MenuList, otherwise the Select does not
// use it
export class MenuList extends Component {
  render() {
    const height = 35;
    const { options, children, maxHeight, getValue } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;

    return (
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={height}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  }
}
